import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { PlaybookRunDetail, PlaybookRunList } from "@/api/types";

const REFETCH_MS = 30_000;

interface RunsArgs {
  page: number;
  perPage: number;
}

export function useRuns({ page, perPage }: RunsArgs) {
  return useQuery({
    queryKey: ["runs", { page, perPage }],
    queryFn: ({ signal }) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("per_page", String(perPage));
      return api<PlaybookRunList>(`/api/v1/playbook-runs?${params.toString()}`, { signal });
    },
    refetchInterval: REFETCH_MS,
    placeholderData: (prev) => prev,
  });
}

export function useRun(runId: string | undefined) {
  return useQuery({
    queryKey: ["run", runId],
    queryFn: ({ signal }) =>
      api<PlaybookRunDetail>(`/api/v1/playbook-runs/${runId}`, { signal }),
    enabled: !!runId,
  });
}
